import { render, staticRenderFns } from "./GiftCardSkeleton.vue?vue&type=template&id=16b74727&scoped=true"
import script from "./GiftCardSkeleton.vue?vue&type=script&lang=js"
export * from "./GiftCardSkeleton.vue?vue&type=script&lang=js"
import style0 from "./GiftCardSkeleton.vue?vue&type=style&index=0&id=16b74727&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b74727",
  null
  
)

export default component.exports